import React, { Component } from 'react';
import '../App.css';
import 'react-stepzilla/src/css/main.css';
import { HashRouter as Router, Route, Link } from "react-router-dom";
import Modal from 'react-modal';
import Utils from '../utils';

// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import {CSVLink, CSVDownload} from 'react-csv';

const queryString = require('query-string');

const moment = require('moment');

const modalStyle = {
    content : {
        top                   : '14%',
        left                  : '14%',
        right                 : '14%',
        bottom                : '14%'
    },
};
class Overview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            environment: "prod",
            isLoading: false,
            apps: [],
            products: {},
            proxies: {},
            exactFilter: false,
            openModal: false
        };

        this.overviewState = {
            developerAppName: "",
            displayName: "",
            productName: "",
            proxyName: "",
            deploymentType: "",
            virtualPath: "",
            targetPath: ""
        }

        this.filters = [];
        this.URL=window.location.href.split("#")[0];
    }

    changeEnvironment = async (e) => {

        await this.setState({
            environment: e.target.value,
            isLoading: true
        });

        this.updateURL();

    }

    updateURL= () => {
        let urlStart = this.URL + "#/overview/";
        let array = [];
        array.push("t=0");
        if (this.state.environment != null) {

            array.push("environment=" + this.state.environment);
        }else{
            array.push("environment=prod")
        }
        array.push("exactfilter=" + this.state.exactFilter);
        this.filters.forEach(f => {
            if(f.id!==(this.URL+"#/overview")&&(f.id!==(this.URL+"#/overview/?t"))) {
                array.push(f.id.trim() + "=" + f.value.trim());
            }
        });

        let queryParamsStr = array.join("&");
        window.location.href = urlStart + "?" + queryParamsStr;
    }

    createRow = (appId, appName, displayName, productName, proxyName, deploymentName, virtualPath, targetPath) => {
        return {
            appId: appId,
            app: appName,
            displayName: displayName ? displayName : "",
            product: productName ? productName : "",
            proxy: proxyName ? proxyName : "",
            deployment: deploymentName ? deploymentName : "",
            virtual: virtualPath ? virtualPath : "",
            target: targetPath ? targetPath : ""
        }
    }

    renderTable = () => {
        let overviewTable = [];
        let appTable = [];
        let orphanedProductTable = [];
        let orphanedProxyTable = [];

        let apps = this.state.apps !== null ? Object.values(this.state.apps) : this.state.apps;
        let products = this.state.products;
        let proxies = this.state.proxies;
        window.apps = apps;
        window.products = products;
        window.proxies = proxies;
        apps.forEach(app => {
            if(app.products.length == 0) {
                appTable.push(this.createRow(app.appId, app.name, app.displayName));
            }
            app.products.forEach(productName => {
                let product = products[productName];
                if(product.proxies.length == 0) {
                    appTable.push(this.createRow(app.appId, app.name, app.displayName, productName));
                }
                product.proxies.forEach(proxyName => {
                    let proxy = proxies[proxyName];
                    if(proxy) {
                        if(proxy.deployments) {
                            let proxyDeployments = Object.values(proxy.deployments);
                            if(proxyDeployments.length == 0) {
                                appTable.push(this.createRow(app.appId, app.name, app.displayName, productName, proxyName));
                            }
                            proxyDeployments.forEach(deployment => {
                                if(!deployment.name.includes('sandbox')){
                                    appTable.push(this.createRow(app.appId, app.name, app.displayName, productName, proxyName, deployment.name, deployment.virtualPath, deployment.targetPath));
                                }
                            });
                        } else {
                            appTable.push(this.createRow(app.appId, app.name, app.displayName, productName, proxyName));
                        }
                    } else {
                        appTable.push(this.createRow(app.appId, app.name, app.displayName, productName, proxyName));
                    }
                });
            });

        });

        let allProductList = [...new Set(Object.keys(products))];
        let nonOrphanedProductList = [...new Set(appTable.map(piece => piece.product))];
        let orphanedProductList = [...new Set(allProductList.filter(product => !nonOrphanedProductList.includes(product)))];

        orphanedProductList.forEach(productName => {
            let product = products[productName];
            product.proxies.forEach(proxyName => {
                let proxy = proxies[proxyName];
                if(proxy) {
                    if(proxy.deployments) {
                        let proxyDeployments = Object.values(proxy.deployments);
                        proxyDeployments.forEach(deployment => {
                            orphanedProductTable.push({
                                app: "",
                                product: product.name ? product.name : "",
                                proxy: proxyName ? proxyName : "",
                                deployment: deployment.name ? deployment.name : "",
                                virtual: deployment.virtualPath ? deployment.virtualPath : "",
                                target: deployment.targetPath ? deployment.targetPath : ""
                            });
                        });
                    }
                } else {
                    orphanedProductTable.push({
                        app: "",
                        product: product.name ? product.name : "",
                        proxy: proxyName ? proxyName : "",
                        deployment: "",
                        virtual: "",
                        target: ""
                    });
                }
            });
        });

        let appsAndProductsTable = appTable.concat(orphanedProductTable);

        let allProxiesList = [...new Set(Object.keys(proxies))];
        let nonOrphanedProxyList = [...new Set(appsAndProductsTable.map(row => row.proxy))];
        let orphanedProxies = [...new Set(allProxiesList.filter(proxy => !nonOrphanedProxyList.includes(proxy)))];

        orphanedProxies.forEach(proxyName => {
            let proxy = proxies[proxyName];
            if(proxy.deployments) {
                let proxyDeployments = Object.values(proxy.deployments);
                proxyDeployments.forEach(deployment => {
                    orphanedProxyTable.push({
                        app: "",
                        product: "",
                        proxy: proxyName ? proxyName : "",
                        deployment: deployment.name ? deployment.name : "",
                        virtual: deployment.virtualPath ? deployment.virtualPath : "",
                        target: deployment.targetPath ? deployment.targetPath : ""
                    });
                });
            } else {
                orphanedProxyTable.push({
                    app: "",
                    product: "",
                    proxy: proxyName ? proxyName : "",
                    deployment: "",
                    virtual: "",
                    target: ""
                });
            }
        });

        overviewTable = appTable.concat(orphanedProductTable, orphanedProxyTable);

        return overviewTable;
    }

    componentDidUpdate() {

        if(this.state.isLoading){
            this.fetchOverview();
        }

    }

    componentDidMount() {

        this.setState({isLoading: true});
        this.consumeQueryParams();
        this.fetchOverview();

    }

    fetchOverview = async () => {
        try {
            const apiName = 'Get Apigee Info API';
            const path = `/${this.state.environment}/overview`;
            const data = await Utils.fetchLambdaApis(apiName, path, null);

            this.setState({
                isLoading: false,
                apps: data.apps,
                products: data.products,
                proxies: data.proxies,
            });
        } catch (error) {
            console.error('Error fetching overview:', error);
            this.setState({ isLoading: false });
        }
    }

    consumeQueryParams = async () => {

        if((this.URL+"/#/overview")=== window.location.href||
            (this.URL+ "/#/overview/?t=0&environment=undefined&exactfilter=false")=== window.location.href||
            (this.URL+ "/#/overview/?t=0"===window.location.href)) {
            return;
        }
        let jsonQs=queryString.parse(window.location.href);

        await this.setState({
            environment: jsonQs.environment,
            exactFilter: jsonQs.exactfilter==="true"
        });


        let tableFilters = jsonQs;
        delete tableFilters.environment;
        delete tableFilters.exactfilter;

        let arr = [];
        Object.entries(tableFilters).forEach(e => {
            arr.push({
                id: e[0],
                value: e[1]
            });
        })

        this.filters = arr;
        this.updateURL();
    }

    clearFilters = () => {
        this.filters=[];
        this.updateURL();
    }

    determineFileName = () => {

        let date = moment().format('YYYY[-]MM[-]DD');
        let environment = this.state.environment;

        return `${date}-apigateway-${environment}.csv`;
    }

    getFilterMethod = () => {
        let comparator;
        if(this.state.exactFilter) {
            comparator = (row, search) => row === search;
        } else {
            comparator = (row, search) => row.indexOf(search) !== -1;
        }
        return (filter, row) => {
            let cellValue = row[filter.id] ? row[filter.id] : "";
            return comparator(cellValue.toLowerCase().trim(), filter.value.toLowerCase().trim());
        }
    }

    changeFilter= async (e) => {
        await this.setState({exactFilter: e.target.checked});
        this.updateURL();
    }

    openModal = () => {
        this.setState({modalIsOpen: true});
    }

    closeModal = () => {
        this.setState({modalIsOpen: false});
    }

    render() {

        const { isLoading, apps, products, proxies } = this.state;
        let tabledata = this.renderTable();
        if(isLoading) {
            return <h2>Loading... (this may take up to 30 seconds)<br/><h4>Note you must have JavaScript Enabled on your browser</h4></h2>
        }

        return (

            <div>
                <span>The Consumers shown are RIS Consumers only.</span>
                <br/>
                <span>You can find information on Non-RIS Consumers and their Proxy Groups and Proxies by downloading reports <a href="https://hudson.ris.principal.com/hudson/job/RISWI/job/apigee-report/ws/" target="_">here</a>.</span>
                <br/>
                <hr/>
                <div>
                    <div className = "col-sm-3">
                        <label htmlFor = "environmentSelector" className = "util-padding-right-10">Environment: </label>
                        <select id = "environmentSelector" className = "btn btn-sm btn-default util-padding-right-10" onChange = {this.changeEnvironment} value = {this.state.environment}>
                            <option value = "prod">Prod</option>
                            <option value = "pilot">Pilot</option>
                            <option value = "test">Test</option>
                        </select>
                    </div>
                    <div className = "col-sm-3">
                        <input data-toggle="toggle" id = "exactFilterCheckbox" type = "checkbox" checked = {this.state.exactFilter} onChange = {this.changeFilter}/>
                        <label htmlFor = "exactFilterCheckbox" className = "util-padding-left-10" value = "">Exact Filter</label>
                    </div>
                    <div className = "col-sm-2">
                        <button className='btn btn-primary btn-sm pull-center'  onClick = {this.clearFilters} >Clear Filters</button>
                    </div>
                    <div className = "col-sm-2">
                        <CSVLink filename = {this.determineFileName()} className = "pull-right btn btn-success btn-sm" data={tabledata}>Download Data <i className="fa fa-download"></i></CSVLink>
                    </div>
                </div>
                <br/><br/><br/>
                <ReactTable
                    data={tabledata}
                    defaultPageSize = {10}
                    defaultFiltered = {this.filters}
                    filterable
                    noDataText = "No Data Found"
                    onFilteredChange={(filters)=>{
                        this.filters=filters;
                        this.updateURL();

                    }}
                    defaultFilterMethod = {this.getFilterMethod()}
                    columns={[
                        {
                            Header: "Consumer Name",
                            accessor: "app",
                        },
                        {
                            Header: "Display Name",
                            accessor: "displayName",
                        },
                        {
                            Header: "Proxy Group Name",
                            accessor: "product"
                        },
                        {
                            Header: "Proxy Name",
                            accessor: "proxy",
                        },
                        {
                            Header: "Deployment Type",
                            accessor: "deployment",
                        },
                        {
                            Header: "Virtual Path",
                            accessor: "virtual",
                        },
                        {
                            Header: "Target Path",
                            accessor: "target"
                        },
                        {
                            Header: "App Id",
                            accessor: "appId",
                        },
                    ]}
                    getTrProps={(state, rowInfo, column, instance) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const rowData = rowInfo.original;
                                this.overviewState = {
                                    appId: rowData.appId,
                                    developerAppName: rowData.app,
                                    displayName: rowData.displayName,
                                    productName: rowData.product,
                                    proxyName: rowData.proxy,
                                    deploymentType: rowData.deployment,
                                    virtualPath: rowData.virtual,
                                    targetPath: rowData.target
                                }
                                this.openModal();

                            }
                        }
                    }}
                />
                <footer>
                    <Link to='/' className='btn btn-primary btn-sm util-margin-top-10'>Back</Link>
                </footer>

                <br/>
                <br/>
                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        style = {modalStyle}
                        contentLabel="Example Modal"
                    >

                        <h2 ref={subtitle => this.subtitle = subtitle}></h2>
                        <button className="btn btn-danger pull-right" onClick={this.closeModal}>X</button>

                        <div className="container util-margin-top-50">
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <span>Consumer Name: </span>
                                </div>
                                <div className="col-md-6">
                                    <span>{this.overviewState.developerAppName}</span>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <span>Display Name: </span>
                                </div>
                                <div className="col-md-6">
                                    <span>{this.overviewState.displayName}</span>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <span>Proxy Group Name: </span>
                                </div>
                                <div className="col-md-6">
                                    <span>{this.overviewState.productName}</span>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <span>Proxy Name: </span>
                                </div>
                                <div className="col-md-6">
                                    <span>{this.overviewState.proxyName}</span>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <span>Deployment Type: </span>
                                </div>
                                <div className="col-md-6">
                                    <span>{this.overviewState.deploymentType}</span>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <span>Virtual Path: </span>
                                </div>
                                <div className="col-md-6">
                                    <span>{this.overviewState.virtualPath}</span>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <span>Target Path: </span>
                                </div>
                                <div className="col-md-6">
                                    <span>{this.overviewState.targetPath}</span>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <span>App Id: </span>
                                </div>
                                <div className="col-md-6">
                                    <span>{this.overviewState.appId}</span>
                                </div>
                            </div>
                            <hr/>
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default Overview;